
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M7.8 12c-1.067-.055-1.967-.466-2.7-1.233C4.367 10 4 9.077 4 8c0-1.11.389-2.055 1.167-2.833C5.944 4.389 6.889 4 8 4c1.078 0 2 .367 2.767 1.1.766.734 1.177 1.634 1.233 2.7l-1.4-.417a2.629 2.629 0 00-.933-1.474A2.585 2.585 0 008 5.333c-.733 0-1.361.26-1.883.783A2.568 2.568 0 005.333 8c0 .633.192 1.189.575 1.667a2.63 2.63 0 001.475.933L7.8 12zm.8 2.633c-.1.023-.2.034-.3.034H8a6.492 6.492 0 01-2.6-.525 6.732 6.732 0 01-2.117-1.425A6.732 6.732 0 011.858 10.6 6.492 6.492 0 011.333 8c0-.922.175-1.789.525-2.6a6.732 6.732 0 011.425-2.117c.6-.6 1.306-1.075 2.117-1.424A6.492 6.492 0 018 1.333c.922 0 1.789.175 2.6.526.811.35 1.517.825 2.117 1.425.6.6 1.075 1.305 1.425 2.116.35.811.525 1.678.525 2.6v.3c0 .1-.011.2-.034.3l-1.3-.4V8c0-1.489-.516-2.75-1.55-3.783C10.75 3.184 9.49 2.667 8 2.667c-1.489 0-2.75.517-3.783 1.55C3.183 5.25 2.667 6.51 2.667 8c0 1.49.516 2.75 1.55 3.784C5.25 12.816 6.51 13.334 8 13.334h.2l.4 1.3zm5.083.367l-2.85-2.85L10 14.667 8 8l6.667 2-2.517.834 2.85 2.85L13.683 15z","fill":"#396BDB"}})])])
          )
        }
      }
    